import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hook';
import {
  MINIMUM_ORDER_CLICK_AND_COLLECT_ERROR,
  MINIMUM_ORDER_DELIVERY_ERROR,
  ORDER_TYPE_CLICK_AND_COLLECT,
  ORDER_TYPE_DELIVERY,
  PRIMARY,
  SECONDARY,
} from '../../../constants';
import {
  showCartModal,
  showConnexionModal,
  showMessageModal,
} from '../../../redux/actions';
import Button from '../../Button';
import { sendOrderMessenger } from '../CartModal.services';
import { displayPriceFormat, isQrCode, isWebView } from '../../../utils';
import _ from 'lodash';
import Spinner from '../../Spinner';
import { verifyPendingOrderValidity } from '../../../Pages/Home/Home.services';

type CartModalFooterProps = {
  resetState: () => void;
  choosePayment: boolean;
  setChoosePayment: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function CartModalFooter({
  resetState,
  choosePayment,
  setChoosePayment,
  loading,
  setLoading,
}: CartModalFooterProps) {
  const dispatch = useAppDispatch();

  const { userConnected } = useAppSelector((state) => state.userReducer);
  const { multiOrder } = useAppSelector((state) => state.configurationReducer);

  const { orders } = useAppSelector((state) => state.orderReducer);
  const {
    commande,
    address: customerAddress,
    totalPriceOrder,
    orderType,
  } = useAppSelector((state) => state.pendingOrderReducer);
  const { minimum, minimumClickAndCollect } = useAppSelector(
    (state) => state.shopReducer,
  );

  return _.isEmpty(commande) ? (
    <Button
      type={SECONDARY}
      onClick={() => {
        dispatch(showCartModal(false));
        resetState();
      }}
    >
      Fermer
    </Button>
  ) : choosePayment ? (
    <Button
      type={SECONDARY}
      onClick={() => setChoosePayment(false)}
    >
      Retour
    </Button>
  ) : loading ? (
    <Spinner />
  ) : (
    <>
      <Button
        type={SECONDARY}
        onClick={() => {
          dispatch(showCartModal(false));
          resetState();
        }}
      >
        Fermer
      </Button>
      {!_.isEmpty(commande) && customerAddress && (
        <Button
          type={PRIMARY}
          className={`btn`}
          onClick={async () => {
            const currentTotalPriceOrder = totalPriceOrder;
            if (isWebView()) {
              sendOrderMessenger(setLoading);
            } else if (!multiOrder && !_.isEmpty(orders)) {
              dispatch(
                showMessageModal(
                  `Vous ne pouvez pas valider votre panier car vous avez déjà ${
                    _.size(orders) > 1
                      ? `${_.size(orders)} commandes`
                      : 'une commande'
                  } en cours`,
                ),
              );
            } else if (userConnected || isQrCode()) {
              setLoading(true);

              const newTotalPriceOrder = await verifyPendingOrderValidity();
              setLoading(false);

              if (typeof newTotalPriceOrder !== 'number') {
                return;
              }

              if (
                orderType === ORDER_TYPE_DELIVERY &&
                totalPriceOrder < minimum
              ) {
                dispatch(
                  showMessageModal(
                    MINIMUM_ORDER_DELIVERY_ERROR(
                      displayPriceFormat(minimum, false, true),
                    ),
                  ),
                );
                return;
              }

              if (
                orderType === ORDER_TYPE_CLICK_AND_COLLECT &&
                totalPriceOrder < minimumClickAndCollect
              ) {
                dispatch(
                  showMessageModal(
                    MINIMUM_ORDER_CLICK_AND_COLLECT_ERROR(
                      displayPriceFormat(minimumClickAndCollect, false, true),
                    ),
                  ),
                );
                return;
              }

              if (newTotalPriceOrder === currentTotalPriceOrder) {
                setChoosePayment(true);
              }
            } else {
              dispatch(showConnexionModal(true));
            }
          }}
        >
          Commander
        </Button>
      )}
    </>
  );
}
